import { AxiosError } from 'axios'
import { QueryClient } from '@tanstack/react-query'

/**
 * TanStack Query para todo lo que venga del servidor.
 *
 * No se reintenta un 4xx: si la API dijo 401, 403 o 404, insistir solo demora
 * la pantalla. Los fallos de red si se reintentan un par de veces, y despues
 * la pantalla degrada con su boton de reintentar.
 */
export function crearClienteDeConsultas(): QueryClient {
  return new QueryClient({
    defaultOptions: {
      queries: {
        retry: (intentos, error) => {
          const estado = error instanceof AxiosError ? error.response?.status : undefined

          if (estado !== undefined && estado >= 400 && estado < 500) {
            return false
          }

          return intentos < 2
        },
        staleTime: 30_000,
        refetchOnWindowFocus: false,
      },
      mutations: { retry: false },
    },
  })
}
